
define('template!sdcTranscludeTarget',['directive!sdcTranscludeHere'],function(template){return '<div ng-repeat="transclude in vm.transcludes" sdc-transclude-here="transclude"></div>\r\n';});

